import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { Logger } from '@melio/platform-logger';
import { Features, usePlans } from '@melio/subscriptions-api';

const LOGGER_MONITORING_MESSAGE = 'useFeaturePlansData';

export const useFirstPlanWithFeature = (featureName: keyof Features) => {
  const [isPlatformSubscriptionsEnabled] = useFeature(FeatureFlags.PlatformSubscriptions, false);

  const { data: plans, isFetching } = usePlans({ enabled: isPlatformSubscriptionsEnabled });

  const firstPlanWithFeature = plans?.find((plan) => plan.features[featureName]?.enabled);

  if (plans && !firstPlanWithFeature) {
    Logger.log(
      `${LOGGER_MONITORING_MESSAGE} - a plan with the feature not found. featureName: ${featureName}`,
      'error'
    );
  }

  return { firstPlanWithFeature, isFetching };
};
